var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseServer',{attrs:{"server":_vm.server}},[_vm._v(" "+_vm._s(_vm.server.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }